<template>
  <div class="marketing-email-form-models">

    <loading v-if="loading"
             class="marketing-automation-form-models-loading" />

    <template v-else>
      <marketing-email-form-models-section :title="$t('message.email.message.basic')">

        <marketing-email-form-models-item class="marketing-email-form-models-section-body-item"
                                          v-for="(model, index) in models.basic"
                                          :key="index"
                                          :model="model"
                                          @click="selectModel(model)" />

      </marketing-email-form-models-section>

      <marketing-email-form-models-section :title="$t('message.email.message.readyTemplates')">
        <marketing-email-form-models-item class="marketing-email-form-models-section-body-item"
                                          v-for="(model, index) in models.custom"
                                          :key="index"
                                          :model="model"
                                          @click="selectModel(model)" />
      </marketing-email-form-models-section>
    </template>

  </div>
</template>

<script>
import Loading from "@/components/generic/Loading.vue";
import MarketingEmailFormModelsItem from "@components/modules/marketing/email/form/models/item/MarketingEmailFormModelsItem";
import MarketingEmailFormModelsSection from "@components/modules/marketing/email/form/models/section/MarketingEmailFormModelsSection";

export default {
  components: {
    MarketingEmailFormModelsItem,
    MarketingEmailFormModelsSection,
    Loading,
  },

  computed: {},

  mounted() {
    this.fetchModels();
  },

  methods: {
    isHtmlModel(model) {
      return model.editorType === "HTML";
    },
    selectModel({ htmlContent, cssStyle, editorType }) {
      this.$emit("selected", { htmlContent, cssStyle, editorType });
    },
    async fetchModels() {
      this.loading = true;

      const models = await this.$api.marketing.email.message.templates();

      this.models = models;

      this.loading = false;
    },
  },

  data() {
    return {
      loading: false,
      models: {
        basic: [],
        custom: [],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-form-models {
  margin-left: 100px;
  padding-bottom: 50px;

  .marketing-email-form-models-section {
    margin-bottom: 30px;

    .marketing-email-form-models-section-title {
      color: #707070;
      font-size: 24px;
    }

    .marketing-email-form-models-section-body {
      display: flex;
      gap: 30px;
      flex-wrap: wrap;

      .marketing-email-form-models-section-body-item {
        flex-shrink: 0;
      }
    }
  }

  .marketing-automation-form-models-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }
}
</style>

